<template>
  <signup :title="title()"
          :sub-title="'ליצירת החשבון נצטרך כמה פרטים:'"
          :button-title="'הצטרפות לשירות'"
          :button-action="generateCodeAndProceed"
          :error="errors.generateCode"
          :reset-error="() => resetError('generateCode')">
    <template v-slot:header>
      <img class="header-image" :src="require('@/assets/invite-member-top.png')">
    </template>
  </signup>
</template>

<script>
import Signup from '@/base-components/Signup';
import { mapMutations, mapState, mapActions } from 'vuex';
import Intercom from '@/Intercom';
import Segment from '../../../../../Segment';

export default {
  name: 'MemberInviteEnterDetails',
  components: {
    Signup,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('MemberInviteEnterDetailsEntered');
  },
  computed: {
    ...mapState('memberInvite', ['errors']),
    ...mapState('inviteSession', ['primaryMemberDetails', 'customerId']),
  },
  methods: {
    ...mapMutations('memberInvite', ['setFirstName', 'setLastName', 'setPhoneNumber', 'resetError', 'setEmail', 'setEnableMarketingEmails']),
    ...mapActions('memberInvite', ['generateCode']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      await this.setEmail(email);
      await this.setEnableMarketingEmails(enableMarketingEmails);
      await this.generateCode();
      await Intercom.boot(
        this.customerId, this.primaryMemberDetails.firstNamePiiValue,
        {
          numberOfMembers: 2,
          phone2: phoneNumber,
          firstName2: firstName,
        },
      );
      this.next();
    },
    title() {
      return `הוזמנת למנוי משותף עם ${this.primaryMemberDetails.firstNamePiiValue}, ביחד קל יותר לנצח את החודש!`;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-image {
  width: 100%;
}
</style>
